/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Modal from 'react-modal';
import Swal from "sweetalert2";
import { postRequest, getRequest, putRequest } from "utils/request";
import { CircularProgress, Tooltip, makeStyles } from "@material-ui/core";
import CreatableSelect from 'react-select/creatable';

import { i18n } from '../../../../translate/i18n';

import SortableTree from '@nosferatu500/react-sortable-tree';
import '@nosferatu500/react-sortable-tree/style.css';

class InteractionNode {
  key = '';
  type = '';
  file = null;
  nameFile = null;
  typeFile = null;
  answerType = null;
  label = '';
  answer = '';
  level = 1;
  endOfBot = false;
  goToOperator = 0;
  operatorId = null;
  CompanyDepartmentId = null;
  nextInteraction = 0;
  backInteraction = 0;
  active = true;
  parentKey = 0;
}

class Bot {
  id = '';
  description = '';
  wordsCallOperator = '';
  numberOfRetries = '';
  OperatorMessage = '';
  CompanyId;

  constructor (companyId) {
    this.CompanyId = companyId;
  }
}

export default function TabNewBot({ companyId, selectedEditBot, setSelectedBot, updateBots, setNewBot, match }) {
  //FLAG QUE DIZ SE ESTÁ CRIANDO BOT OU EDITANDO BOT
  const [addBot, setAddBot] = useState(false);
  //MODAIS
  const [createNodeModalVisible, setCreateNodeModalVisible] = useState(false);
  const [editNodeModalVisible, setEditNodeModalVisible] = useState(false);
 
  //LOADING DE CARREAMENTO DO BOT
  const [loading, setLoading] = useState(true);
  const [bot, setBot] = useState(new Bot(companyId));
  const [wordsCall, setWordsCall] = useState([]);
  const [wordsCallOptions, setWordsCallOptions] = useState([]);
  const [interactionsList, setInteractionsList] = useState([]);
  const [companyStatus, setCompanyStatus] = useState([]);
  const [companyOperators, setCompanyOperators] = useState([]);
  const [companyDepartments, setCompanyDepartments] = useState([]);

  //NODE QUE SENDO EDITADO OU CRIADO
  const [interactionNode, setInteractionNode] = useState(new InteractionNode());

  //NODE PAI DO QUE ESTA SENDO EDITADO OU CRIADO
  const [selectedNode, setSelectedNode] = useState(new InteractionNode());
  const [nextStep, setNextStep] = useState();
  const [editNextStep, setEditNextStep] = useState();

  //NODE
  const [nodes, setNodes] = useState([]);

  //TODAS AS INTERAÇÕES DEPOIS DE MAPEADAS
  let interactions = [];
  let interactionList = [];
  let treeOrder = 1;
  let unlinkedInteractions = [];


  const [nodeDb, setNodeDb] = useState([])

  const useStyles = makeStyles((theme) => ({
    customWidth: {
      fontSize: 16,
    },
  }));
  const classes = useStyles();

  //MODAL STYLES
  const customStyles = {
    content : {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '60%',
      minHeight: '80%'
    },
    overlay: {
      overflow: 'auto',
      // transition: '(top 0.4s, opacity 0.4s)',
      zIndex: 1002,
      background: 'rgba(0, 0, 0, 0.4)',
    }
  };

  const getDetachedInteraction = (id, interactions = [], node = null) => {
    let interactionsNew
    let interactionsOptions = [];

    if(interactions.length > 0) {
      interactionsNew = interactions.filter(e => e.nextInteraction === id || e.backInteraction === id);
      interactions.forEach(e => {
        e?.BotInteractionOptions?.forEach(b => {
          if(b.nextInteraction === id || b.backInteraction === id) {
            interactionsOptions.push(e);
          }
        })
      })
    } else {
      interactionsNew = interactionsList.filter(e => e.nextInteraction === id || e.backInteraction === id);
      interactionsList.forEach(e => {
        e.BotInteractionOptions.forEach(b => {
          if(b.nextInteraction === id || b.backInteraction === id) {
            interactionsOptions.push(e);
          }
        })
      })
    }

    if(interactionsNew.length === 0 && interactionsOptions.length === 0) {
      if(node && interactions.length > 0 && node.id !== interactions[0].id) {
        const childrens = getChildrensInLoad(node, [], 0, interactions);
        if(childrens.length > 0) {
          childrens.forEach(e => {
            unlinkedInteractions.push(e);
          })
        }
      }
      return true;
    } else {
      return false;
    }
  }

  //CRIAR BOT
  const handleCreateBot = () => {
    if(selectedEditBot) {
      putRequest(`/bots/${selectedEditBot.id}`, bot).then(e => {
        if(e.success) {
          updateBots();
          loadBot(e.data.id);
          setAddBot(false);
        }
      })
    } else {
      //FUNÇÂO DE REQUEST NA API
      postRequest('/bots' , bot).then(function(response) {
        if(response.success) {
          updateBots();
          loadBot(response.data.id)
          setAddBot(false);
        }
      })
    }
  }

  //FUNÇÃO QUE MAPEIA AS INTERAÇÕES EM TREE STRUCTURE
  function createBotTree(arrEntrada, arrSaida = [], parentKey = null, lastMenuOptions = null) {
    for (let i = 0; i < arrEntrada.length; i++) {
        const item = arrEntrada[i];
        treeOrder = treeOrder + 1

        let backInterationLabel;
        const interactionIndex = interactionList.findIndex(e => e.id === arrEntrada[i].backInteration);

        if(interactionIndex >= 0) {
          backInterationLabel = interactionList[interactionIndex].interaction;
        }

        let object;
        if (item.BotId) {
        //interaction
          object = {
            key: item.id,
            type: 'interaction',
            backInterationLabel,
            answerType: item.answerType,
            label: item.interaction,
            title: item.interaction.length > 99 ? item.interaction.substr(0,100) + '...' : item.interaction,
            goToOperator: item.goToOperator,
            operatorId: item.operatorId,
            CompanyDepartmentId: item.CompanyDepartmentId,
            backInteraction: item.backInteraction, 
            CompanyStatusId: item.CompanyStatusId,
            typeExpected: item.typeExpected,
            endOfBot: item.endOfBot,
            treeOrder,
            order: item.order,
            description: item.description,
            isDetach: item.isDetach,
            expanded: true,
            level: item.level,
            icon: item.typeExpected === 1 ? 'pi pi-comments' : item.typeExpected === 3 ? 'pi pi-image' : item.typeExpected === 2 ? 'pi pi-list' : 'pi pi-info-circle',
            nextInteraction: item.nextInteraction,
            parentKey,
            children: item?.children?.length > 0 ? item.children : []
          }
          if (item.nextInteraction > 0) {
            const children = interactions.filter(c => c.id === item.nextInteraction)

            if(children[0]?.level > item?.level) {
              createBotTree(children, object.children, object.key);
            } else if (children[0]?.level === item?.level && lastMenuOptions) {
              createBotTree(children, lastMenuOptions.children, object.key, lastMenuOptions);
            }
          } else if (item.BotInteractionOptions.length > 0) {
            createBotTree(item.BotInteractionOptions, object.children);
          }
        } else {

          let backInterationLabel;
          const interactionIndex = interactionList.findIndex(e => e.id === arrEntrada[i].backInteration);
  
          if(interactionIndex >= 0) {
            backInterationLabel = interactionList[interactionIndex].interaction;
          }
        //interaction option
          object = {
            key: item.id,
            type: 'interactionOption',
            label: item.description,
            typeExpected: item.typeExpected,
            title: item.description.length > 99 ? item.description.substr(0,100) + '...' : item.description,
            description: item.description,
            treeOrder,
            answer: item.answer,
            backInterationLabel: backInterationLabel,
            answerType: item.answer ? "2" : item.answerType,
            expanded: true,
            level: item.level,
            CompanyStatusId: item.CompanyStatusId,
            goToOperator: item.goToOperator,
            operatorId: item.operatorId,
            CompanyDepartmentId: item.CompanyDepartmentId,
            backInteraction: item.backInteraction, 
            endOfBot: item.endOfBot,
            order: item.order,
            nextInteraction: item.nextInteraction,
            icon: 'pi pi-circle-off',
            children: []
          }
          if (item.nextInteraction > 0) {
            const children = interactions.filter(c => c.id === item.nextInteraction);
            if(children[0]?.level > item.level) {
              createBotTree(children, object.children, null, object);
            }
          }
        }
        if(object.children.length > 0 && object.answer) {
          object.children = object.children.sort((a,b) => a.treeOrder - b.treeOrder);
        }
        arrSaida.push(object);
    }
    return arrSaida;
  }

  //CARREGAR INTERAÇÔES DE BOT
  const loadBot = (botId) => {
    setLoading(true);
    getRequest(`bots/interactions/${botId}`).then(e => {
      if(e.success) {
        interactionList = e.data
        setInteractionsList(e.data);
      }
    })

    getRequest(`/companiesstatus?CompanyId=${match.params.id}`)
    .then(function (response) {
      const data = response.data.filter(e => e.statusUser === 4 && e.active);
      setCompanyStatus(data);
    });

    getRequest(`/users/staff/${companyId}?onlyActive=1`)
    .then(function (response) {
      const data = response.data;
      setCompanyOperators(data);
    });

    getRequest(`/companiesdepartments/bycompany?CompanyId=${companyId}&onlyActive=1`)
    .then(function (response) {
      const data = response.data;
      setCompanyDepartments(data);
    });

    getRequest(`bots/${botId}`).then(function(response) {
      if(response.success){
        let { data } = response;
        if (data) {
          interactions = data.BotInteractions;
          if (interactions && interactions.length > 0) {
            let baseInteractions = [];
            let filteredInteractions = [];


            interactions.forEach((i, index) => {
              i.goToOperator = i.goToOperator === true ? 1 : 0;
              i.operatorId = i.operatorId;
              i.BotInteractionOptions.forEach((io, index) => {
                io.goToOperator = io.goToOperator === true ? 1 : 0;
                io.operatorId = io.operatorId;
                io.CompanyDepartmentId = io.CompanyDepartmentId;
              })
            });

            //Procura as interações que estejam linkadas com outras. Ou seja, alguma interação leva a ela. caso contrário, joga para o final da lista
            interactions.forEach((e, index) => {
              if( ((!getDetachedInteraction(e.id, interactions, e) || e.order === 1))) {
                filteredInteractions.push(e)
              }
            })

            //filtra as interações para pegar os niveis 0
            baseInteractions = filteredInteractions.filter(i => (!i.level || i.level === 0));

            //organiza por ordem númerica no campo ORDER 
            baseInteractions = baseInteractions.sort((a,b) => a.order - b.order);



            //Pega as interações sem links com outras.
            interactions.forEach((e, index) => {
              if( getDetachedInteraction(e.id, interactions) && e.id !== baseInteractions[0]?.id ) {
                baseInteractions.push(e);
                const childrens = getChildrensInLoad(e, [], e.level, interactions);
                if(childrens.length > 0) {
                  childrens.forEach(c => {
                    const idx = baseInteractions.findIndex(bi => bi.id === c.id);
                    if(idx >= 0) {
                      baseInteractions.splice(idx, 1)
                    }
                    if(!c.answer) {
                      c.isDetach = true;
                      baseInteractions.push(c);
                    }
                  })
                }
              }
            })

            const nodes = createBotTree(baseInteractions);

            setNodes(nodes);
            setNodeDb(nodes);
          } else {
            setNodes([]);
          };
          setBot(data);
        }
      }})
    .finally(() => {
      setLoading(false);
    })
  }

  const createFirstInteraction = () => {
    postRequest(nodes.length === 0 ? '/bots/interactions' : '/bots/interactions/continueBot', 
      {
        interaction: interactionNode.label,
        answerType: interactionNode.answerType,
        typeExpected: interactionNode.answerType === '4' ? 4 : interactionNode.typeExpected ? interactionNode.typeExpected : 2,
        file: interactionNode.file ?? null,
        nameFile: interactionNode.nameFile ?? null,
        title: interactionNode.label,
        typeFile: interactionNode.typeFile ?? null, 
        goToOperator: interactionNode.goToOperator ?? 0 ,
        operatorId: (interactionNode.operatorId) ? interactionNode.operatorId : null,
        CompanyDepartmentId: interactionNode.CompanyDepartmentId ? Number(interactionNode.CompanyDepartmentId) : null,
        endOfBot: interactionNode.endOfBot ?? 0,
        CompanyStatusId: interactionNode.CompanyStatusId ?? null,
        order: nodes.length === 0 ? 1 : nodes[nodes.length - 1].order + 1,
        nextInteraction: 0,
        backInteraction: 0,
        level: 0,
        BotId: bot.id
      }
    ).then(function(response) {
      if(response.success) {
        setCreateNodeModalVisible(false);
        setInteractionNode(new InteractionNode());
        loadBot(bot.id);
      }
    })
  }

  //CRIAR INTERAÇÂO DE BOT
  const createBotInteraction = () => {
    if(!!selectedNode.answer && !!interactionNode.answer) {
      return Swal.fire({
        title: "Erro",
        text: i18n.t('doubleInteractionOption'),
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
    if(!interactionNode.answer) {
        if (selectedNode && selectedNode.children.length > 0) {
          return Swal.fire({
            title: "Erro",
            text: i18n.t('onlyOneChild'),
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
        //CRIA O FILHO
        postRequest('/bots/interactions', 
        {
          interaction: interactionNode.label,
          title: interactionNode.label,
          typeExpected: interactionNode.answerType === '4' ? 4 : interactionNode.typeExpected ? interactionNode.typeExpected : 2,
          answerType: interactionNode.answerType,
          file: interactionNode.file ?? null,
          nameFile: interactionNode.nameFile ?? null, 
          typeFile: interactionNode.typeFile ?? null, 
          goToOperator: interactionNode.goToOperator ?? 0,
          operatorId: (interactionNode.operatorId) ? interactionNode.operatorId : null,
          CompanyDepartmentId: interactionNode.CompanyDepartmentId ? Number(interactionNode.CompanyDepartmentId) : null,
          CompanyStatusId: interactionNode.CompanyStatusId,
          endOfBot: interactionNode.endOfBot ?? 0,
          nextInteraction: 0,
          order: selectedNode.children.length > 0 ? selectedNode.children[selectedNode.children.length - 1].order + 1 : selectedNode.order + 1,
          backInteraction: interactionNode.backInteraction,
          level: !selectedNode.answer ? selectedNode.level : selectedNode.level + 1,
          BotId: bot.id
        }).then(function(response) {
          if(response.data) {
            if(!!!selectedNode.answer) {

              //ATUALIZA O PAI
              putRequest(`/bots/interactions/${selectedNode.key}`, 
              {
                interaction: selectedNode.label,
                title: selectedNode.label,
                typeExpected: selectedNode.typeExpected ? selectedNode.typeExpected : 2,
                file: selectedNode.file ?? null,
                nameFile: selectedNode.nameFile ?? null, 
                CompanyStatusId: selectedNode.CompanyStatusId,
                typeFile: selectedNode.typeFile ?? null, 
                level: selectedNode.level,
                order: selectedNode.order,
                goToOperator: selectedNode.goToOperator ?? 0,
                operatorId: (selectedNode.operatorId) ? selectedNode.operatorId : null,
                CompanyDepartmentId: selectedNode.CompanyDepartmentId ? Number(selectedNode.CompanyDepartmentId) : null,
                endOfBot: selectedNode.endOfBot ?? 0,
                active: true,
                nextInteraction: response.data.id,
                backInteraction: selectedNode.backInteraction
              }).then(function(response) {
                if(response.success) {
                  loadBot(bot.id);
                }
              })
            } else {
              putRequest(`/bots/interactions/options/${selectedNode.key}`, 
              {
                description: `(${selectedNode.answer}) ${selectedNode.description.substr(4)}`,
                answer: selectedNode.answer,
                goToOperator: selectedNode.goToOperator,
                operatorId: (selectedNode.operatorId) ? selectedNode.operatorId : null,
                CompanyDepartmentId: selectedNode.CompanyDepartmentId ? Number(selectedNode.CompanyDepartmentId) : null,
                CompanyStatusId: selectedNode.CompanyStatusId,
                typeExpected: selectedNode.typeExpected,
                endOfBot: selectedNode.endOfBot,
                nextInteraction: response.data.id,
                level: selectedNode.level,
                backInteraction: selectedNode.backInteraction
              }).then(function(response){
                if(response.success) {
                  setEditNodeModalVisible(false);
                  loadBot(bot.id);
                }
              })
            }
          }
        })
    } else {
      if(selectedNode.children.length > 0) {
        const nodesWithSameAnswer = selectedNode.children.filter(e => Number(e.answer) === Number(interactionNode.answer));
        if(nodesWithSameAnswer.length > 0) {
          return Swal.fire({
            title: "Aviso",
            text: i18n.t('alreadyHaveAnswer'),
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      }
      postRequest('/bots/interactions/options', 
      {
        description: `(${interactionNode.answer}) ${interactionNode.description}`,
        answer: interactionNode.answer,
        answerType: interactionNode.answerType,
        goToOperator: interactionNode.goToOperator,
        operatorId: (interactionNode.operatorId) ? interactionNode.operatorId : null,
        CompanyDepartmentId: interactionNode.CompanyDepartmentId ? Number(interactionNode.CompanyDepartmentId) : null,
        CompanyStatusId: interactionNode.CompanyStatusId,
        typeExpected: interactionNode.typeExpected,
        endOfBot: interactionNode.endOfBot,
        order: interactionNode.answer,
        backInteraction: interactionNode.backInteraction,
        nextInteraction: 0, 
        level: selectedNode.level + 1,
        BotInteractionId: selectedNode.key,
      }).then(function(response) {
        if(response.success) {
          loadBot(bot.id);
        }
      })
    }
    setCreateNodeModalVisible(false);
    //Resetar Input
    setInteractionNode(new InteractionNode());
  }
  
  //DELETAR INTERAÇÃO
  function deleteNode(node) {
    if (node.children && node.children.length > 0) {
      return Swal.fire({
        title: "Erro",
        text: i18n.t('removeChildsFirst'),
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }

    if(node.nextInteraction > 0 ) {
      return Swal.fire({
        title: "Erro",
        text: i18n.t('cantRemoveWithNextInteraction'),
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }

    if (node.type === 'interaction') {
      //INATIVANDO INTERAÇÃO FILHA
      putRequest(`bots/interactions/delete/${node.key}`).then(function(response){
        if(response.success) {
            loadBot(bot.id);
          }
      })
    } else {
      putRequest(`/bots/interactions/options/${node.key}`, 
      {
        description: node.label,
        answer: node.answer,
        goToOperator: node.goToOperator,
        operatorId: (node.operatorId) ? node.operatorId : null,
        CompanyDepartmentId: node.CompanyDepartmentId ? Number(node.CompanyDepartmentId) : null,
        endOfBot: node.endOfBot,
        active: false,
        nextInteraction: 0,
        backInteraction: 0
      }).then(function(response){
        if(response.success) {
          loadBot(bot.id);
        }
      })
    }
  }

  //EDITAR INTERAÇÃO
  const handleInteractionUpdate = () => {
    if(selectedNode.type === 'interaction') {
      putRequest(`/bots/interactions/${selectedNode.key}`, 
      {
        interaction: selectedNode.label,
        typeExpected: selectedNode.typeExpected,
        file: selectedNode.file ?? null,
        CompanyStatusId: selectedNode.CompanyStatusId,
        nameFile: selectedNode.nameFile ?? null, 
        typeFile: selectedNode.typeFile ?? null, 
        goToOperator: selectedNode.goToOperator,
        operatorId: (selectedNode.operatorId) ? selectedNode.operatorId : null,
        CompanyDepartmentId: selectedNode.CompanyDepartmentId ? Number(selectedNode.CompanyDepartmentId) : null,
        endOfBot: selectedNode.endOfBot,
        level: selectedNode.level,
        order: selectedNode.order,
        nextInteraction: selectedNode.nextInteraction,
        backInteraction: selectedNode.backInteraction
      }).then(function(response){
        if(response.success) {
          setEditNodeModalVisible(false);
          loadBot(bot.id);
        }
      })
    } else {
      putRequest(`/bots/interactions/options/${selectedNode.key}`, 
      {
        description:`(${selectedNode.answer}) ${selectedNode.label}`,
        answer: selectedNode.answer,
        CompanyStatusId: selectedNode.CompanyStatusId,
        typeExpected: selectedNode.typeExpected,
        goToOperator: selectedNode.goToOperator,
        operatorId: (selectedNode.operatorId) ? selectedNode.operatorId : null,
        CompanyDepartmentId: selectedNode.CompanyDepartmentId ? Number(selectedNode.CompanyDepartmentId) : null,
        endOfBot: selectedNode.endOfBot,
        nextInteraction: selectedNode.nextInteraction,
        backInteraction: selectedNode.backInteraction,
        level: selectedNode.level
      }).then(function(response){
        if(response.success) {
          setEditNodeModalVisible(false);
          loadBot(bot.id);
        }
      })
    }
  }

  //Atualiza interação por evento
  const handleInteractionUpdateByEvent = (e) => {
    if(!e.answer) {
      putRequest(`/bots/interactions/${e.id}`, {...e, message: 1})
    } else {
      putRequest(`/bots/interactions/options/${e.id}`, {...e, message: 1})
    }
  }

  //SELECIONAR NODE E ABRIR MODAL
  const handleOpenNodeModal = async (e, option) => {    
    
    setNextStep("");

    if(option !== 4) {
      const { node } = e;
  
      if (option === 1) {
        //CRIAR INTERAÇÃO
        setSelectedNode({...node, label: node.answer ? node.label.substr(4) : node.label});
        setCreateNodeModalVisible(true);
      } else if (option === 2) {
        //EDITAR INTERAÇÃO
        setSelectedNode({...node, label: node.answer ? node.label.substr(4) : node.label});
        if(node.CompanyDepartmentId) {
          setEditNextStep(2)
        } else if (node.goToOperator) {
          setEditNextStep(1)
        } else if (node.endOfBot) {
          setEditNextStep(3)
        } else {
          setEditNextStep(4)
        }
        setEditNodeModalVisible(true);
      } else if (option === 3) {
        //DELETAR INTERAÇÃO
        Swal.fire({
          title: i18n.t('deleteDesire'),
          showDenyButton: true,
          width: 400,
          padding: 5,
          confirmButtonColor: '#009e0f',
          confirmButtonText: i18n.t('yes'),
          denyButtonText:i18n.t('no'),
          })
          .then((result) => {
            if(result.isConfirmed) {
              deleteNode(node);
            }
          }
        )
      }
    } else {
      setCreateNodeModalVisible(true);
    }
  }
  
  const handleBotInputChange = (e) => {
    const { name, value } = e.target;
    setBot(oldState => { return { ...oldState, [name]: value } })
  }

  const handleNodeInputChange = (e) => {
    const { name, value } = e.target;
    setInteractionNode(oldState => { return { ...oldState, [name]: value } })
  }

  const handleNodeSelectChange = (e) => {
    const { name, value } = e.target
    setInteractionNode(oldState => { return { ...oldState, [name]: value } })
  }

  const handleEditNodeInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedNode(oldState => { return { ...oldState, [name]: value } })
  }

  const handleEditNodeSelectChange = (e) => {
    const { name, value } = e.target
    setSelectedNode(oldState => { return { ...oldState, [name]: value } })
  }

  //Pega os filhos de uma interação, procurando sempre por nextInteraction
  const getChildrens = (node, arrSaida = [], level, order) => {
    let nodeAux = interactionsList.findIndex(e => e.id === node.key);

    if(node?.nextInteraction > 0) {
      const index = interactionsList.findIndex(e => e.id === node.nextInteraction);
      if(index >= 0) {
        if(interactionsList[index].level > 0 || getDetachedInteraction(interactionsList[index].key, [])) {
          interactionsList[index].level = level
          interactionsList[index].order = order
        }
        arrSaida.push(interactionsList[index]);
        getChildrens(interactionsList[index], arrSaida, interactionsList[index].level, order + 1);
      }
    }

    if(nodeAux >= 0) {
      if(interactionsList[nodeAux].typeExpected === 2 && interactionsList[nodeAux].BotInteractionOptions?.length > 0) {
        interactionsList[nodeAux].BotInteractionOptions.forEach(e => {
          e.level = node.level + 1
          arrSaida.push(e);
          if(e.nextInteraction > 0) {
            getChildrens(e, arrSaida, e.level + 1, order)
          }
        })
      }
    } else {
      if(node.typeExpected === 2 && node?.BotInteractionOptions?.length > 0) {
        node.BotInteractionOptions.forEach(e => {
          e.level = node.level + 1
          arrSaida.push(e);
          if(e.nextInteraction > 0) {
            getChildrens(e, arrSaida, e.level + 1, order)
          }
        })
      }
    }
    return arrSaida;
  }

  //Pega os filhos de uma interação, procurando sempre por nextInteraction, faz isso no carregamento do bot
  const getChildrensInLoad = (node, arrSaida = [], level, interactions) => {
    let nodeAux = interactions.findIndex(e => e.id === node.key);

    if(node?.nextInteraction > 0) {
      const index = interactions.findIndex(e => e.id === node.nextInteraction);
      interactions[index].level = level
      arrSaida.push(interactions[index]);
      getChildrensInLoad(interactions[index], arrSaida, interactions[index].level, interactions);
    }

    if(nodeAux >= 0) {
      if(interactions[nodeAux].typeExpected === 2 && interactions[nodeAux].BotInteractionOptions?.length > 0) {
        interactions[nodeAux].BotInteractionOptions.forEach(e => {
          e.level = node.level + 1
          arrSaida.push(e);
          if(e.nextInteraction > 0) {
            getChildrensInLoad(e, arrSaida, e.level + 1, interactions)
          }
        })
      }
    } else {
      if(node.typeExpected === 2 && node?.BotInteractionOptions?.length > 0) {
        node.BotInteractionOptions.forEach(e => {
          e.level = node.level + 1
          arrSaida.push(e);
          if(e.nextInteraction > 0) {
            getChildrensInLoad(e, arrSaida, e.level + 1, interactions)
          }
        })
      }
    }
    return arrSaida;
  }

  //Pega os filhos de uma interação, procurando sempre por nextInteraction, faz isso ao arrastar um bot
  const getChildrensToDrop = (node, arrSaida = [], order, level) => {
    let nodeAux = interactionsList.findIndex(e => e.id === node.key);
    
    if(node?.nextInteraction > 0) {
      const index = interactionsList.findIndex(e => e.id === node.nextInteraction);
      if(index >= 0) {
        interactionsList[index].order = order;
        interactionsList[index].level = level;
        arrSaida.push(interactionsList[index]);
        getChildrensToDrop(interactionsList[index], arrSaida, order + 1, level);
      }
    }

    if(nodeAux >= 0) {
      if(interactionsList[nodeAux].typeExpected === 2 && interactionsList[nodeAux].BotInteractionOptions?.length > 0) {
        interactionsList[nodeAux].BotInteractionOptions.forEach(e => {
          e.level = node.level + 1
          arrSaida.push(e);
          if(e.nextInteraction > 0) {
            getChildrensToDrop(e, arrSaida, order, level + 1)
          }
        })
      }
    } else {
      if(node.typeExpected === 2 && node?.BotInteractionOptions?.length > 0) {
        node.level = level
        node.BotInteractionOptions.forEach(e => {
          e.level = node.level + 1
          arrSaida.push(e);
          if(e.nextInteraction > 0) {
            getChildrensToDrop(e, arrSaida, order, level + 1)
          }
        })
      }
    }
    return arrSaida;
  }

  const dragNode = (e) => {
    const { node, nextParentNode: father} = e;

    //Pega os filhos do node para arrastar junto com o pai
    let childrens = []
    if((node.nextInteraction > 0 && father.level !== node.level) || (node.typeExpected === 2 && father.level !== node.level)) {
      childrens = getChildrens(node, [], father.typeExpected !== 2 ? father.answer ? father.level + 1 : father.level : father.level + 2, father.order + 2);
    }

    if(JSON.stringify(e.treeData) !== JSON.stringify(nodeDb)) {
      if(node.type === 'interaction') {
        putRequest(`/bots/interactions/${node.key}`, 
        {
          interaction: node.label,
          typeExpected: node.typeExpected,
          file: node.file ?? null,
          CompanyStatusId: node.CompanyStatusId,
          nameFile: node.nameFile ?? null, 
          typeFile: node.typeFile ?? null, 
          goToOperator: node.goToOperator,
          operatorId: node.operatorId,
          CompanyDepartmentId: node.CompanyDepartmentId,
          endOfBot: node.endOfBot,
          order: father.answer ? 1 : father.order + 1,
          level: father.answer ? father.level + 1 : father.level,
          nextInteraction: node.typeExpected !== 2 ? childrens.length === 0 ? father.nextInteraction ? father.nextInteraction : node.nextInteraction : node.nextInteraction : 0,
          backInteraction: node.backInteraction,
          isDragging: true
        }).then(function(response){
          if(response.success) {
            if(childrens.length > 0) {
              //Caso tenha filho, atualiza por evento.
              childrens.forEach((b, index) => {
                if(b.level > 0) {
                  handleInteractionUpdateByEvent(b);
                }
              })
            }
            //Atualiza o pai antigo
            updateOldFather(node, e);
            //Atualiza o pai novo
            updateFather(e);
          }
        })
      } else {
        putRequest(`/bots/interactions/options/${node.key}`, 
        {
          description: node.label,
          answer: node.answer,
          level: father.level + 1,
          CompanyStatusId: node.CompanyStatusId,
          typeExpected: node.typeExpected,
          goToOperator: node.goToOperator,
          operatorId: (node.operatorId) ? node.operatorId : null,
          CompanyDepartmentId: node.CompanyDepartmentId ? Number(node.CompanyDepartmentId) : null,
          endOfBot: node.endOfBot,
          nextInteraction: father.nextInteraction ? father.nextInteraction : node.nextInteraction,
          backInteraction: node.backInteraction,
          BotInteractionId: father.key,
          isDragging: true
        }).then(function(response){
          if(response.success) {
            if(childrens.length > 0) {
              childrens.forEach(b => {
                handleInteractionUpdateByEvent(b);
              })
            }
          }
        }).finally(() => {
          //Carrega o bot novamente no final.
          loadBot(bot.id)
        })
      }
    }
  }

  //Arrasta para o nivel 0
  const dragLevel0 = (e) => {
    const { node, treeIndex, treeData, nextParentNode: father} = e;

    // Pega os filhos quando arrastar para o nivel 0
    const nodeChildrens = getChildrensToDrop(node, [], treeData[treeIndex - 1].order + 2, treeData[treeIndex - 1].typeExpected === 2 ? 2 : 0);

    // if(JSON.stringify(e.treeData) !== JSON.stringify(nodeDb)) {
      if(node.type === 'interaction') {

        putRequest(`/bots/interactions/${node.key}`, 
        {
          interaction: node.label,
          typeExpected: node.typeExpected,
          file: node.file ?? null,
          CompanyStatusId: node.CompanyStatusId,
          nameFile: node.nameFile ?? null, 
          typeFile: node.typeFile ?? null, 
          goToOperator: node.goToOperator,
          operatorId: node.operatorId ?? null,
          CompanyDepartmentId: node.CompanyDepartmentId ?? null,
          endOfBot: node.endOfBot,
          order: treeData[treeIndex - 1].order + 1,
          level: 0,
          nextInteraction: node.nextInteraction,
          backInteraction: node.backInteraction,
          isDragging: true
        }).then(function(response){
          if(response.success) {
            if(node.nextInteraction) {
              if(nodeChildrens.length > 0) {
                nodeChildrens.forEach(e => {
                  handleInteractionUpdateByEvent(e);
                })
              }
            }
            //Atualiza o pai antigo
            updateOldFather(node, e);
            //Atualiza o novo pai
            updateFatherLevel0(e);
          }
        })
      } else {
        putRequest(`/bots/interactions/options/${node.key}`, 
        {
          description: node.label,
          answer: node.answer,
          level: treeData[treeIndex - 1].level + 1,
          CompanyStatusId: node.CompanyStatusId,
          typeExpected: node.typeExpected,
          goToOperator: node.goToOperator,
          operatorId: (node.operatorId) ? node.operatorId : null,
          CompanyDepartmentId: node.CompanyDepartmentId ? Number(node.CompanyDepartmentId) : null,
          endOfBot: node.endOfBot,
          nextInteraction: father.nextInteraction ? father.nextInteraction : node.nextInteraction,
          backInteraction: node.backInteraction,
          BotInteractionId: father.key,
          isDragging: true
        }).then(function(response){
          if(response.success) {
            if(nodeChildrens.length > 0) {
              nodeChildrens.forEach(b => {
                handleInteractionUpdateByEvent(b);
              })
            }
          }
        }).finally(() => {
          loadBot(bot.id)
        })
      }
    // }
  }

  //Arrasta para o final level 0
  const dragToEnd = (e) => {
    const { node, treeData} = e;

    // Pega os filhos quando arrastar para o nivel 0
    const nodeChildrens = getChildrensToDrop(node, [], treeData[treeData.length - 2].order + 2, 0);
    if(node.type === 'interaction') {
      putRequest(`/bots/interactions/${node.key}`, 
      {
        interaction: node.label,
        typeExpected: node.typeExpected,
        file: node.file ?? null,
        CompanyStatusId: node.CompanyStatusId,
        nameFile: node.nameFile ?? null, 
        typeFile: node.typeFile ?? null, 
        goToOperator: node.goToOperator,
        operatorId: node.operatorId ?? null,
        CompanyDepartmentId: node.CompanyDepartmentId ?? null,
        endOfBot: node.endOfBot,
        order: treeData[treeData.length - 2].order + 1,
        level: 0,
        nextInteraction: node.nextInteraction,
        backInteraction: node.backInteraction,
        isDragging: true
      }).then(function(response){
        if(response.success) {
          if(node.nextInteraction) {
            if(nodeChildrens.length > 0) {
              nodeChildrens.forEach(e => {
                handleInteractionUpdateByEvent(e);
              })
            }
          }
          //Atualiza o novo pai
          updateOldFather(node, e);
          updateFatherInTheEnd(e);
        }
      }).finally(() => {
        loadBot(bot.id)
      })
    }
  }

  //Arrasta o node para começar o bot
  const dragNodeToStart = (e) => {
    const { node, treeData } = e;
    
    if(JSON.stringify(e.treeData) !== JSON.stringify(nodeDb)) {

      let order = 1;
      treeData.forEach(td => {
          putRequest(`/bots/interactions/${td.key}`, 
          {
            interaction: td.label,
            typeExpected: td.typeExpected,
            file: td.file ?? null,
            CompanyStatusId: td.CompanyStatusId,
            nameFile: td.nameFile ?? null, 
            typeFile: td.typeFile ?? null, 
            goToOperator: td.goToOperator,
            operatorId: td.operatorId ?? null,
            CompanyDepartmentId: td.CompanyDepartmentId ?? null,
            endOfBot: td.endOfBot,
            order,
            level: 0,
            nextInteraction: td.typeExpected === 2 ? 0 : td.key === node.key ? treeData[1].key : td.nextInteraction,
            backInteraction: td.backInteraction,
            isDragging: true
          })
          order = order + 1
      })
      //Atualiza o antigo bot e carrega novamente
      updateOldFather(node, e);
      loadBot(bot.id);
    }
  }

  const updateOldFather = (node, event) => {
    const { treeData, treeIndex, nextParentNode } =  event;
    let options = [];
    let interactions = [];
    interactionsList.forEach(e => {
      if(e.nextInteraction === node.key && (e.level === node.level || e.backInteraction === node.key)) {
        interactions.push(e);
      }
      if(e.BotInteractionOptions.length > 0) {
        e.BotInteractionOptions.forEach(opt => {
          if(opt.nextInteraction === node.key || opt.backInteraction === node.key) {
            options.push(opt);
          }
        })
      }
    })

    if(options.length > 0) {
      options.forEach(e => {
        putRequest(`/bots/interactions/options/${e.id}`, 
        {
          description: e.label,
          answer: e.answer,
          level: e.level,
          CompanyStatusId: e.CompanyStatusId,
          BotInteractionId: e.key,
          typeExpected: e.typeExpected,
          goToOperator: e.goToOperator,
          operatorId: (e.operatorId) ? e.operatorId : null,
          CompanyDepartmentId: e.CompanyDepartmentId ? Number(e.CompanyDepartmentId) : null,
          endOfBot: e.endOfBot,
          nextInteraction: 0,
          backInteraction: 0,
          isDragging: true
        })
      })
    }

    if(interactions.length > 0) {
      interactions.forEach(e => {
        putRequest(`/bots/interactions/${e.id}`, 
        {
          interaction: e.label,
          typeExpected: e.typeExpected,
          file: e.file ?? null,
          CompanyStatusId: e.CompanyStatusId,
          nameFile: e.nameFile ?? null, 
          typeFile: e.typeFile ?? null, 
          goToOperator: e.goToOperator,
          operatorId: (e.operatorId) ? e.operatorId : null,
          CompanyDepartmentId: e.CompanyDepartmentId ? Number(e.CompanyDepartmentId) : null,
          endOfBot: e.endOfBot,
          level: e.level,
          order: node.order,
          nextInteraction: 0,
          backInteraction: 0,
          isDragging: true
        })
      })
    }
  }

  const updateFather = (e) => {
    const { node, nextParentNode: father} = e;
    if(father.type === 'interaction') {
      putRequest(`/bots/interactions/${father.key}`, 
      {
        interaction: father.label,
        typeExpected: father.typeExpected,
        file: father.file ?? null,
        CompanyStatusId: father.CompanyStatusId,
        nameFile: father.nameFile ?? null, 
        typeFile: father.typeFile ?? null, 
        goToOperator: 0,
        operatorId: (father.operatorId) ? father.operatorId : null,
        CompanyDepartmentId: father.CompanyDepartmentId ? Number(father.CompanyDepartmentId) : null,
        endOfBot: 0,
        order: father.order,
        level: father.level,
        nextInteraction: father.typeExpected !== 2 ? node.key : 0,
        backInteraction: father.backInteraction,
        isDragging: true
      }).then(function(response){
        if(response.success) {
          loadBot(bot.id);
        }
      })
    } else {
      putRequest(`/bots/interactions/options/${father.key}`, 
      {
        description: father.label,
        answer: father.answer,
        level: father.level,
        CompanyStatusId: 0,
        BotInteractionId: father.BotInteractionId,
        typeExpected: father.typeExpected,
        goToOperator: 0,
        operatorId: null,
        CompanyDepartmentId: null,
        endOfBot: 0,
        nextInteraction: node.key,
        backInteraction: father.backInteraction,
        isDragging: true
      }).then(function(response){
        if(response.success) {
          loadBot(bot.id);
        }
      })
    }
  }

  const updateFatherLevel0 = (e) => {
    const { node, nextParentNode: father, treeData, treeIndex} = e;
    if(treeData[treeIndex - 1].type === 'interaction') {
      putRequest(`/bots/interactions/${treeData[treeIndex - 1].key}`, 
      {
        interaction: treeData[treeIndex - 1].label,
        typeExpected: treeData[treeIndex - 1].typeExpected,
        file: treeData[treeIndex - 1].file ?? null,
        CompanyStatusId: treeData[treeIndex - 1].CompanyStatusId,
        nameFile: treeData[treeIndex - 1].nameFile ?? null, 
        typeFile: treeData[treeIndex - 1].typeFile ?? null, 
        goToOperator: 0,
        operatorId: treeData[treeIndex - 1].operatorId ?? null,
        CompanyDepartmentId: treeData[treeIndex - 1].CompanyDepartmentId ?? null,
        endOfBot: 0,
        order: treeData[treeIndex - 1].order,
        level: treeData[treeIndex - 1].level,
        nextInteraction: treeData[treeIndex - 1].typeExpected !== 2 ? node.key : 0,
        backInteraction: treeData[treeIndex - 1].backInteraction,
        isDragging: true
      }).then(function(response){
        if(response.success) {
          loadBot(bot.id);
        }
      })
    } else {
      putRequest(`/bots/interactions/options/${father.key}`, 
      {
        description: father.label,
        answer: father.answer,
        level: father.level,
        CompanyStatusId: 0,
        BotInteractionId: father.BotInteractionId,
        typeExpected: father.typeExpected,
        goToOperator: 0,
        operatorId: null,
        CompanyDepartmentId: null,
        endOfBot: 0,
        nextInteraction: node.key,
        backInteraction: father.backInteraction,
        isDragging: true
      }).then(function(response){
        if(response.success) {
          loadBot(bot.id);
        }
      })
    }
  }

  const updateFatherInTheEnd = (e) => {
    const { node, nextParentNode: father, treeData, treeIndex} = e;

    putRequest(`/bots/interactions/${treeData[treeData.length - 2].key}`, 
    {
      interaction: treeData[treeData.length - 2].label,
      typeExpected: treeData[treeData.length - 2].typeExpected,
      file: treeData[treeData.length - 2].file ?? null,
      CompanyStatusId: treeData[treeData.length - 2].CompanyStatusId,
      nameFile: treeData[treeData.length - 2].nameFile ?? null, 
      typeFile: treeData[treeData.length - 2].typeFile ?? null, 
      goToOperator: 0,
      operatorId: null,
      CompanyDepartmentId: null,
      endOfBot: 0,
      order: treeData[treeData.length - 2].order,
      level: treeData[treeData.length - 2].level,
      nextInteraction: treeData[treeData.length - 2].typeExpected !== 2 ? node.key : 0,
      backInteraction: treeData[treeData.length - 2].backInteraction,
      isDragging: true
    }).then(function(response){
      if(response.success) {
        loadBot(bot.id);
      }
    })
  }

  //Função que retorna a permissão de arrastar a interação do bot
  const getPermissionToDrop = (node, father, nextTreeIndex, e) => {
    if(father?.level === 0) {
      return true;
    }
    if(!father && e.nextTreeIndex >= 1) {
      return false;
    } else {
      if(nextTreeIndex === 0) {
        return false;      
      } else {
        if(father?.children.length > 0 || (father?.level === 0 && father?.typeExpected !== 2)) {
          if(father.children[0].key === node.key || node.answer) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    }
  }

  const handleDropNode = (e) => {
    const { node, nextParent: father, nextTreeIndex} = e;
    if( ((father?.treeOrder > node?.treeOrder && node.level === 0)) || 
        ((father?.typeExpected === 1 || father?.typeExpected === 3 || father?.typeExpected === 4)  && node.type !== "interaction")  || 
        ((father?.typeExpected === 2)  && node.type !== "interactionOption") || getPermissionToDrop(node, father, nextTreeIndex, e)  ||
        (node?.answer && father?.typeExpected !== 2) || father?.nextInteraction === node.key ||
        (father?.typeExpected !== 2 && father?.children.length > 1 && father?.children[0].nextInteraction === node.key) ||
        node.nextInteraction === father?.key
        ) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    if(!editNodeModalVisible && !createNodeModalVisible) {
      setSelectedNode(new InteractionNode());
      setInteractionNode(new InteractionNode());
    }
  }, [editNodeModalVisible, createNodeModalVisible])

  useEffect(() => {
    if(!!nextStep) {
      setInteractionNode({ ...interactionNode, goToOperator: 0, endOfBot: 0, CompanyDepartmentId: null })
    }
    if(Number(nextStep) === 1) {
      setInteractionNode({ ...interactionNode, goToOperator: 1, endOfBot: 1, CompanyStatusId: null, CompanyDepartmentId: null })
    } else if (Number(nextStep) === 2) {
      setInteractionNode({ ...interactionNode, endOfBot: 1, goToOperator: 1, operatorId: null })
    } else if (Number(nextStep) === 3) {
      setInteractionNode({ ...interactionNode, endOfBot: 1, goToOperator: 0, operatorId: null, CompanyDepartmentId: null})
    } else if(Number(nextStep) === 4) {
      setInteractionNode({ ...interactionNode, goToOperator: 0, operatorId: null, endOfBot: 0, backInteraction: 0, CompanyStatusId: null, CompanyDepartmentId: null })
    }
  }, [nextStep]);
  
  useEffect(() => {
    if(!!editNextStep) {
      setSelectedNode(oldState => { return { ...oldState, goToOperator: 0, endOfBot: 0, CompanyDepartmentId: null} })
    }
    if(Number(editNextStep) === 1) {
      setSelectedNode({ ...selectedNode, goToOperator: 1, endOfBot: 1, CompanyStatusId: null, CompanyDepartmentId: null } )
    } else if (Number(editNextStep) === 2) {
      setSelectedNode({ ...selectedNode, endOfBot: 1, goToOperator: 1, operatorId: null})
    } else if (Number(editNextStep) === 3) {
      setSelectedNode({ ...selectedNode, endOfBot: 1, goToOperator: 0, operatorId: null, CompanyDepartmentId: null})
    } else if(Number(editNextStep) === 4) {
      setSelectedNode({ ...selectedNode, goToOperator: 0, operatorId: null, endOfBot: 0, backInteraction: 0, CompanyStatusId: null, CompanyDepartmentId: null } )
    }
  }, [editNextStep])

  //AO ENTRAR NA PAGINA, VERIFICA SE JA EXISTIA UM BOT
  useEffect(() => {
    if(selectedEditBot) {
      if(typeof selectedEditBot.wordsCallOperator === 'string') {
        let words = selectedEditBot.wordsCallOperator.split(';')        
        words.forEach(function (e) {
          wordsCallOptions.push({label: e, value: e});
          setWordsCallOptions([...wordsCallOptions])
          setWordsCall([...wordsCallOptions])
        });
      }
      setBot(selectedEditBot)
      loadBot(selectedEditBot.id);
    } else {
      setLoading(false);
    }
    setAddBot(true);
  }, []);

  if (loading) {
    return (
      <div className="area-loading">
        <CircularProgress />
      </div>
    )
  }

  const handleGoBack = () => {
    setNewBot(false);
    setAddBot(false);
    setSelectedBot();
  }

  const multiSelectChange = (event) => {
    setWordsCall(event);
    let wordsOperatorArr = [];

    event.forEach(e => {
      wordsOperatorArr.push(e.value)
    })

    setBot({...bot, wordsCallOperator: wordsOperatorArr.join(';')})
  }

  function changeNode (e) {
    setNodes(e);
  }

  //Define qual função usar ao arrastar interação
  const handleDrag = (e) => {
    const { treeIndex, treeData, nextParentNode, node } = e;
    if(treeIndex > 0) {
      if(!nextParentNode) {
        if(treeData[treeData.length - 1].key === node.key) {
          dragToEnd(e);
        } else {
          dragLevel0(e);
        }
      } else {
        dragNode(e);
      }
    } else {
      dragNodeToStart(e);
    }
  }

  return(
    <div className="new-bot-container">
      {/* CRIAR NODE CHILDREN */}
      <Modal 
        ariaHideApp={false}
        isOpen={createNodeModalVisible}
        onRequestClose={() => setCreateNodeModalVisible(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <form 
          onSubmit={(e) => {
          e.preventDefault();
          if ( nodes.length < 1 || selectedNode.key < 1 ) {createFirstInteraction()} else {createBotInteraction()};
          }} 
          className="form-edit"
        >
          {selectedNode.typeExpected !== 2 && 
            <div className="bot-modal-input">
              <label className="bot-modal-label">{i18n.t('option')}*:</label>
              <select required name="answerType" value={interactionNode.answerType} onChange={(e) => {setInteractionNode(); handleNodeSelectChange(e)}} className="form-control select2">
                <option value="">{i18n.t('select')}</option>
                <option value="1">Menu</option>
                <option value="2">{i18n.t('question')}</option>
                <option value="4">{i18n.t('informactive')}</option>
              </select>
            </div>
          }

          {interactionNode.answerType &&
            <div className="bot-modal-input">
              <label className="bot-modal-label">{Number(interactionNode.answerType) === 1 ? i18n.t('text') : i18n.t('question')}*:</label>
              <textarea maxLength={990} rows={4} style={{resize: 'none'}} required name="label" value={interactionNode.label} onChange={handleNodeInputChange} className="form-control"></textarea>
            </div>
          }


          {(interactionNode.answerType === '2' || interactionNode.answerType === '4') && selectedNode.typeExpected !== 2 && (
            <>
              {Number(interactionNode.answerType) === 2 && (
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('answerType')} *:</label>
                <select required name="typeExpected" value={interactionNode.typeExpected} onChange={handleNodeSelectChange} className="form-control">
                  <option value="">{i18n.t('select')}</option>
                  <option value="1">{i18n.t('text')}</option>
                  <option value="3">{i18n.t('image')}</option>
                </select>
              </div>
              )}

              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('nextStep')} *:</label>
                <select required name="nextStep" value={nextStep} onChange={(e) => setNextStep(e.target.value)} className="form-control">
                  <option value="">{i18n.t('select')}</option>
                  <option value={1}>{i18n.t('goToOperator')}</option>
                  <option value={2}>{i18n.t('goToDepartment')}</option>
                  <option value={3}>{i18n.t('endOfBot')}</option>
                  <option value={4}>{i18n.t('interaction')}</option>
                </select>
              </div>
              {(Number(nextStep) === 1) && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('selectOperator')} *:</label>
                  <select required name="operatorId" value={interactionNode.operatorId} onChange={handleNodeSelectChange} className="form-control">
                    <option value="">{i18n.t('select')}</option>
                    {companyOperators.map(e => (
                      <option key={e.id} value={e.id}>{e.nickName}</option>
                    ))}
                  </select>
                </div>
              }
              {(Number(nextStep) === 2) && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('selectDepartment')} *:</label>
                  <select required name="CompanyDepartmentId" value={interactionNode.CompanyDepartmentId} onChange={handleNodeSelectChange} className="form-control">
                    <option value="">{i18n.t('select')}</option>
                    {companyDepartments.map(e => (
                      <option key={e.id} value={e.id}>{e.description}</option>
                    ))}
                  </select>
                </div>
              }
              {(Number(nextStep) === 3) && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('concludedStatus')} *:</label>
                  <select required name="CompanyStatusId" value={interactionNode.CompanyStatusId} onChange={handleNodeSelectChange} className="form-control">
                    <option value="">{i18n.t('select')}</option>
                    {companyStatus.map(e => (
                      <option key={e.id} value={e.id}>{e.externalDescription}</option>
                    ))}
                  </select>
                </div>
              }
              {(Number(nextStep) === 4 )&& 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('interaction')} *:</label>
                  <select required name="backInteraction" value={interactionNode.backInteraction} onChange={handleNodeSelectChange} className="form-control">
                    <option value={0}>{i18n.t('registryLater')}</option>
                    {interactionsList.map(e => (
                      <option key={e.id} value={e.id}>{e.interaction.length > 50 ? e.interaction.substr(0,49) + '...' : e.interaction}</option>
                    ))}
                  </select>
                </div>
              }
            </>
          )}
          {selectedNode.typeExpected === 2 && 
          <>
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('text')} *:</label>
                <input disabled value={selectedNode.title} className="form-control"/>
              </div>
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('description')} *:</label>
                <textarea rows={2} style={{resize: 'none'}} maxLength={990} required name="description" value={interactionNode.description} onChange={handleNodeInputChange} className="form-control"/>
              </div>

              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('expectedAnswer')}'ex 1, 2' *:</label>
                <input type="number" min={1} required name="answer" value={interactionNode.answer} onChange={handleNodeInputChange} className="form-control"/>
              </div>

              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('nextStep')} *:</label>
                <select required name="nextStep" value={nextStep} onChange={(e) => setNextStep(e.target.value)} className="form-control">
                  <option value="">{i18n.t('select')}</option>
                  <option value={1}>{i18n.t('goToOperator')}</option>
                  <option value={2}>{i18n.t('goToDepartment')}</option>
                  <option value={3}>{i18n.t('endOfBot')}</option>
                  <option value={4}>{i18n.t('interaction')}</option>
                </select>
              </div>
              {(Number(nextStep) === 1) && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('selectOperator')} *:</label>
                  <select required name="operatorId" value={interactionNode.operatorId} onChange={handleNodeSelectChange} className="form-control">
                    <option value="">{i18n.t('select')}</option>
                    {companyOperators.map(e => (
                      <option key={e.id} value={e.id}>{e.nickName}</option>
                    ))}
                  </select>
                </div>
              }
              {(Number(nextStep) === 2) && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('selectDepartment')} *:</label>
                  <select required name="CompanyDepartmentId" value={interactionNode.CompanyDepartmentId} onChange={handleNodeSelectChange} className="form-control">
                    <option value="">{i18n.t('select')}</option>
                    {companyDepartments.map(e => (
                      <option key={e.id} value={e.id}>{e.description}</option>
                    ))}
                  </select>
                </div>
              }
              {Number(nextStep) === 3 && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('concludedStatus')} *:</label>
                  <select required name="CompanyStatusId" value={interactionNode.CompanyStatusId} onChange={handleNodeSelectChange} className="form-control">
                    <option  value="">{i18n.t('select')}</option>
                    {companyStatus.map(e => (
                      <option key={e.id} value={e.id}>{e.externalDescription}</option>
                    ))}
                  </select>
                </div>
              }
              {Number(nextStep) === 4 && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('interaction')} *:</label>
                  <select required name="backInteraction" value={interactionNode.backInteraction} onChange={handleNodeSelectChange} className="form-control">
                    <option value={0}>{i18n.t('registryLater')}</option>
                    {interactionsList.map(e => (
                      <option key={e.id} value={e.id}>{e.interaction.length > 50 ? e.interaction.substr(0,49) + '...' : e.interaction}</option>
                    ))}
                  </select>
                </div>
              }
            </>
          }
          {(interactionNode.answerType || selectedNode.typeExpected === 2) && 
            <div style={{ paddingBottom: 20, marginLeft: 'auto', marginTop: 'auto', paddingTop: 20}}>
              <button style={{marginRight: 10}} type="button" className="btn btn-outline-danger" onClick={() => setCreateNodeModalVisible(false)}>
                  <i className="mdi mdi-backup-restore"></i> {i18n.t('cancel')}
              </button>
              <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
              </button>
            </div>
          }
        </form>
      </Modal>
      {/* EDITAR NODE */}
      <Modal 
        ariaHideApp={false}
        isOpen={editNodeModalVisible}
        onRequestClose={() => setEditNodeModalVisible(false)}
        style={customStyles}
      >
        {selectedNode && 
        <form 
        onSubmit={(e) => {
            e.preventDefault();
            handleInteractionUpdate(e);
            }} 
            className="form-edit"
        >

         {!selectedNode.answer && 
            <div className="bot-modal-input">
              <label className="bot-modal-label">{i18n.t('option')}*:</label>
              <select disabled required name="answerType" value={(Number(selectedNode.typeExpected) === 3 || Number(selectedNode.typeExpected) === 1) ? 2 : Number(selectedNode.typeExpected) === 2 ? 1 : 4} onChange={(e) => {handleEditNodeSelectChange(e)}} className="form-control select2">
                <option value="1">Menu</option>
                <option value="2">{i18n.t('question')}</option>
                <option value="4">{i18n.t('informactive')}</option>
              </select>
            </div>
          }

            <div className="bot-modal-input">
              <label className="bot-modal-label">{Number(selectedNode.typeExpected) === 1 || Number(selectedNode.typeExpected) === 3 ?  i18n.t('question') : i18n.t('text')}*:</label>
              <textarea rows={4} style={{resize: 'none'}} required name="label" value={selectedNode.label} onChange={handleEditNodeInputChange} className="form-control"></textarea>
            </div>

            {(Number(selectedNode.typeExpected) === 1 || Number(selectedNode.typeExpected) === 3) && 
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('answerType')} *:</label>
                <select required name="typeExpected" value={selectedNode.typeExpected} onChange={handleEditNodeInputChange} className="form-control">
                  <option value="1">{i18n.t('text')}</option>
                  <option value="3">{i18n.t('image')}</option>
                </select>
              </div>
            }

            {selectedNode.answer &&
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('expectedAnswer')}(ex 1, 2) *:</label>
                <input type="number" min={1} required name="answer" value={selectedNode.answer} onChange={handleEditNodeInputChange} className="form-control"/>
              </div>
            }
            {Number(selectedNode.typeExpected) !== 2 && 
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('nextStep')} *:</label>
                <select required name="editNextStep" value={editNextStep} onChange={(e) => setEditNextStep(e.target.value)} className="form-control">
                  <option value="">{i18n.t('select')}</option>
                  <option value={1}>{i18n.t('goToOperator')}</option>
                  <option value={2}>{i18n.t('goToDepartment')}</option>
                  <option value={3}>{i18n.t('endOfBot')}</option>
                  <option value={4}>{i18n.t('interaction')}</option>
                </select>
              </div>
            }
            {Number(editNextStep) === 1 && 
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('selectOperator')} *:</label>
                <select required name="operatorId" value={selectedNode.operatorId} onChange={handleEditNodeSelectChange} className="form-control">
                  <option value="">{i18n.t('select')}</option>
                  {companyOperators.map(e => (
                    <option key={e.id} value={e.id}>{e.nickName}</option>
                  ))}
                </select>
              </div>
            }
            {(Number(editNextStep) === 2) && 
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('selectDepartment')} *:</label>
                  <select required name="CompanyDepartmentId" value={selectedNode.CompanyDepartmentId} onChange={handleEditNodeSelectChange} className="form-control">
                    <option value="">{i18n.t('select')}</option>
                    {companyDepartments.map(e => (
                      <option key={e.id} value={e.id}>{e.description}</option>
                    ))}
                  </select>
                </div>
              }
            {Number(editNextStep) === 3 && 
              <div className="bot-modal-input">
                <label className="bot-modal-label">{i18n.t('concludedStatus')} *:</label>
                <select required name="CompanyStatusId" value={selectedNode.CompanyStatusId} onChange={handleEditNodeSelectChange} className="form-control">
                  <option  value="">{i18n.t('select')}</option>
                  {companyStatus.map(e => (
                    <option key={e.id} value={e.id}>{e.externalDescription}</option>
                  ))}
                </select>
              </div>
            }
            {Number(editNextStep) === 4 && Number(selectedNode.typeExpected) !== 2 && (
              selectedNode.nextInteraction ? (
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('interaction')} *:</label>
                  <select required name={"nextInteraction"} value={selectedNode.nextInteraction || selectedNode.backInteraction} onChange={handleEditNodeSelectChange} className="form-control">
                    <option value={0}>{i18n.t('registryLater')}</option>
                    {interactionsList.map(e => (
                      <option key={e.id} value={e.id}>{e.interaction.length > 50 ? e.interaction.substr(0,49) + '...' : e.interaction}</option>
                    ))}
                  </select>
                </div>
              )
              :
              (
                <div className="bot-modal-input">
                  <label className="bot-modal-label">{i18n.t('interaction')} *:</label>
                  <select required name={"backInteraction"} value={selectedNode.backInteraction} onChange={handleEditNodeSelectChange} className="form-control">
                    <option value={0}>{i18n.t('registryLater')}</option>
                    {interactionsList.map(e => (
                      <option key={e.id} value={e.id}>{e.interaction.length > 50 ? e.interaction.substr(0,49) + '...' : e.interaction}</option>
                    ))}
                  </select>
                </div>
              )
            )}
            <div style={{ paddingBottom: 20, marginLeft: 'auto', marginTop: 'auto', paddingTop: 20}}>
              <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
              </button>
            </div>
          </form>
        }

      </Modal>
      <div className="new-bot-title">
        <h1><i className="fas fa-robot" style={{marginRight: 10}}></i>{selectedEditBot ? i18n.t('editBot') : i18n.t('createBot')}</h1>
      </div>
    {addBot ? 
      <form 
        onSubmit={(e) => {
            e.preventDefault();
            handleCreateBot();
            }} 
            className="form-edit"
        >
        <div className="new-bot-input">
            <label className="col-form-label">{i18n.t('description')} *:</label>
            <input required name="description" value={bot.description} onChange={handleBotInputChange} style={{width: '40%'}} className="form-control"></input>
        </div>
        <div className="new-bot-input">
        <label className="col-form-label">{i18n.t('wordsToAddOperator')} *: </label>
          <div style={{width: '40%'}}>
            <CreatableSelect 
              isMulti 
              onChange={multiSelectChange} 
              value={wordsCall} 
              noOptionsMessage={() => i18n.t('noCallOperator')}
              options={wordsCallOptions}
              formatCreateLabel={(e) => `Adicionar "${e}"`}
            />
          </div>
        </div>
        <div className="new-bot-input">
        <label className="col-form-label">{i18n.t('numberOfTries')} *:</label>
            <input min={1} name="numberOfRetries" value={bot.numberOfRetries} onChange={handleBotInputChange} required type='number' style={{width: '10%'}} className="form-control"></input>
        </div>
        <div style={{height: '20vh'}} className="new-bot-input">
        <label className="col-form-label">{i18n.t('wordsToRedirect')} *:</label>
            <input name="OperatorMessage" value={bot.OperatorMessage} onChange={handleBotInputChange} required style={{width: '40%'}} className="form-control"></input>
        </div>
        <div style={{marginTop: 20, marginLeft: 'auto'}}>
          <button
            type="button"
            className="btn btn-outline-danger"
            onClick={() => handleGoBack()}
            style={{marginRight: 10}}
          >
            <i className="mdi mdi-backup-restore"></i>
            {i18n.t('getBack')}
          </button>
          <button type="submit" className="btn btn-outline-success">
              <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
          </button>
          {bot.id && 
            <button onClick={() =>  setAddBot(false)}style={{marginLeft: 10}} type="button" className="btn btn-outline-success">
                <i className="fas fa-arrow-right"></i> {i18n.t('nextStep')}
            </button>
          }
        </div>
      </form>
    : 
      <div>
        {nodes.length === 0 ? 
          <>
            <div className="bot-add-tree" onClick={() => setCreateNodeModalVisible(true)}>
              <i className="fas fa-plus-circle add-bot"></i>
              <label className="col-form-label" style={{fontSize: 25, cursor: 'pointer'}}>{i18n.t('clickToStart')}</label>
            </div>
            <div style={{position: 'absolute', bottom: 20, right: 10, zIndex: 500}}>
              <button onClick={() =>  setAddBot(true)}style={{marginRight: 10}} type="button" className="btn btn-outline-success">
                <i className="fas fa-arrow-left"></i> {i18n.t('backStep')}
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i className="mdi mdi-backup-restore"></i>
                {i18n.t('getBack')}
              </button>
            </div>
          </>
        :
        <div style={{minHeight: 500}}>
          <div style={{width: '77vw', minHeight: 450, overflowY: 'auto', position: 'relative', zIndex: 1}}>
            <SortableTree
              treeData={nodes}
              onChange={changeNode}
              canDrop={handleDropNode}
              onMoveNode={handleDrag}
              canDrag={true}
              isVirtualized={false}
              generateNodeProps={rowInfo => ({
                buttons: [
                  <>
                    {((getDetachedInteraction(rowInfo.node.key, []) && !rowInfo.node.answer && rowInfo.node.key !== nodes[0].key) || (rowInfo.node.isDetach)) && (
                    <Tooltip 
                      arrow
                      classes={{tooltip: classes.customWidth}}
                      title={ 
                        i18n.t('detachedInteraction')
                      } 
                    >
                      <button 
                        className="sortableTree-button"
                        style={{color: 'red'}}
                      >
                        <i className="fas fa-exclamation-triangle"/>
                      </button>
                    </Tooltip>
                    )}
                  </>,
                  <Tooltip 
                  arrow
                  classes={{tooltip: classes.customWidth}}
                  title={ 
                    rowInfo.node.label
                  } 
                  >
                    <button 
                      className="sortableTree-button" 
                      style={{display:rowInfo.node.label.length < 99 && "none" ,position: 'absolute', width: '15%', height: '65%', right: 126}}
                    />
                  </Tooltip>,
                  <>
                    {(rowInfo?.node?.children[0]?.type === "interaction" || rowInfo?.node?.endOfBot || (rowInfo?.node?.type === "interaction" && rowInfo?.node?.nextInteraction > 0))  ?
                    <Tooltip 
                      arrow
                      classes={{tooltip: classes.customWidth}}
                      title={ 
                        rowInfo.node.nextInteraction > 0 ? 
                        i18n.t('cantContinueInteraction')
                        : 
                        i18n.t('cantContinueEndOfBot')
                      } 
                    >
                      <button
                        style={{color: 'green', zIndex: 100, cursor: 'pointer', opacity: 0.2}}
                        className="sortableTree-button"
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </Tooltip>
                  :
                    <Tooltip 
                        arrow
                        classes={{tooltip: classes.customWidth}}
                        title={ 
                          i18n.t('add')
                        } 
                    >
                      <button
                        style={{color: 'green', zIndex: 100}}
                        className="sortableTree-button"
                        onClick={() => {handleOpenNodeModal(rowInfo, 1)}
                      }
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </Tooltip>
                    }
                  </>,
                  <Tooltip 
                  arrow
                  classes={{tooltip: classes.customWidth}}
                  title={ 
                    i18n.t('edit')
                  } 
                  >
                    <button
                      style={{color: 'orange', zIndex: 100}}
                      className="sortableTree-button"
                      onClick={() => handleOpenNodeModal(rowInfo, 2)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                  </Tooltip>,
                  <Tooltip 
                  arrow
                  classes={{tooltip: classes.customWidth}}
                  title={ 
                    i18n.t('delete')
                  } 
                  >
                    <button
                      style={{color: 'red', zIndex: 100}}
                      className="sortableTree-button"
                      onClick={() => handleOpenNodeModal(rowInfo, 3)
                    }
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </Tooltip>,
                  <Tooltip 
                    arrow
                    classes={{tooltip: classes.customWidth}}
                    title={ 
                        Number(rowInfo.node.typeExpected) === 1 ?
                      i18n.t('text')
                      : Number(rowInfo.node.typeExpected) === 3 ?
                      i18n.t('image')
                      : Number(rowInfo.node.typeExpected) === 2 ?
                      'Menu'
                      : Number(rowInfo.node.typeExpected) === 4 ?
                      i18n.t('informactive')
                      : rowInfo.node.answer && i18n.t('menuOption')
                    } 
                  >
                      <button
                        className="sortableTree-button"
                        style={{zIndex: 100, position: 'absolute', left: 0, top: 11}}
                      >
                        <i className={rowInfo.node.icon}></i>
                      </button>
                  </Tooltip>,
                  rowInfo?.node?.backInterationLabel && (
                <Tooltip 
                  arrow
                  classes={{tooltip: classes.customWidth}}
                  title={ 
                    rowInfo?.node?.backInterationLabel?.length > 99 
                    ? rowInfo?.node?.backInterationLabel?.substr(0, 100) + '...'
                    : rowInfo?.node?.backInterationLabel
                    }
                >
                    <button
                      className="sortableTree-button"
                      style={{zIndex: 100, display: rowInfo.node.backInteraction < 1 && 'none'}}
                    >
                      <i className='fas fa-arrow-right'></i>
                    </button>
                </Tooltip>
                  )
                ]
              })
              }
            ></SortableTree>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <button onClick={() => handleOpenNodeModal(new InteractionNode(), 4)} style={{height: 37.8, marginTop: 18}} className="btn btn-outline-success">
                <i className="mdi mdi-plus"></i>
                {i18n.t('continueBot')}
              </button>
              <div style={{marginTop: 20}}>
                <button onClick={() =>  setAddBot(true)}style={{marginRight: 10}} type="button" className="btn btn-outline-success">
                  <i className="fas fa-arrow-left"></i> {i18n.t('backStep')}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => handleGoBack()}
                >
                  <i className="mdi mdi-backup-restore"></i>
                  {i18n.t('getBack')}
                </button>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    }
    </div>
  )
}